import css from 'styled-jsx/css';

export default css`.topicList {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start; }
  .topicList .topicListHeader {
    padding: 12px 0 16px;
    display: flex;
    flex-grow: row;
    justify-content: center;
    align-items: center;
    width: 100%; }
    .topicList .topicListHeader .title {
      color: #666;
      font-weight: bold;
      text-align: center;
      flex: 1; }
    .topicList .topicListHeader .right {
      width: 50px; }
    .topicList .topicListHeader .btnClose {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 50px; }
      .topicList .topicListHeader .btnClose :global(.iconClose) {
        color: #666; }
  .topicList .topicListContent {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    overflow-y: auto;
    height: 65vh; }
    .topicList .topicListContent .topicItem {
      cursor: pointer;
      width: 100%;
      padding: 10px 15px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center; }
      .topicList .topicListContent .topicItem .coverOuter {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center; }
      .topicList .topicListContent .topicItem .btnCheckmark {
        padding: 0 0 0 16px; }
        .topicList .topicListContent .topicItem .btnCheckmark .select {
          width: 16.8px;
          height: 16.8px;
          background-color: #7d7af4;
          border-radius: 50%; }
        .topicList .topicListContent .topicItem .btnCheckmark .unselect {
          width: 16.8px;
          height: 16.8px;
          border: 2px solid #dcdcdc;
          border-radius: 50%; }
        .topicList .topicListContent .topicItem .btnCheckmark .checkmark {
          width: 16.8px;
          height: 16.8px;
          background-color: #7d7af4;
          border-radius: 50%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center; }
          .topicList .topicListContent .topicItem .btnCheckmark .checkmark :global(.iconCheck) {
            color: #fff;
            font-size: 12px;
            margin-top: 1px;
            margin-left: -2px; }
      .topicList .topicListContent .topicItem .iconLock {
        width: 12.8px;
        height: 12.8px;
        margin-left: 4px; }
      .topicList .topicListContent .topicItem .cover {
        width: 48px;
        height: 48px;
        background-color: #d8d8d8;
        border-radius: 5px;
        margin-right: 16px; }
        .topicList .topicListContent .topicItem .cover img {
          width: 100%;
          height: 100%; }
  .topicList .topicListFooter {
    width: 100%;
    padding: 12px 12px 32px; }
    .topicList .topicListFooter :global(.btnSave) {
      width: 100%;
      background-color: #7d7af4;
      color: #fff;
      font-size: 1em;
      padding-top: 3px;
      padding-bottom: 3px; }
`